module.exports = __webpack_public_path__ + "img/agregar-blanco.6f4fef7f.svg";